import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
import { InitialDates } from '../_components/molecules/NewEditDuration';
import { EmployerGroups } from '../core-utils/helper-utils/reportsWorkFlowHelper';
import { ICohortDetails } from '../_components/organisms/CreateNewModalCoreComponent';

export class CustomDashboardStore {
  id: string = '';
  dashboardName: string = '';
  employerGroups: EmployerGroups[] = [];
  isEdit: boolean = false;
  planPeriod: InitialDates = {
    start_month: '',
    end_month: '',
    plan_start_month: '',
    start_year: 0,
    end_year: 0,
    plan_end_month: '',
    recent_plan_year: 0
  };
  selectedStartDate: string = '';
  selectedEndDate: string = '';
  selectedCohorts: ICohortDetails[] = [
    {
      id: 1,
      category: '',
      condition: '',
      property: '',
      results: '',
      dropdownSelectionTypeIndex: 0,
      propertiesPageNumber: 0,
      totalPagesForProperties: 0,
    },
  ];
  tempSelectedCohorts: ICohortDetails[] = [];

  constructor() {
    makeObservable(this, {
      id: observable,
      dashboardName: observable,
      employerGroups: observable,
      isEdit: observable,
      planPeriod: observable,
      selectedEndDate: observable,
      selectedStartDate: observable,
      selectedCohorts: observable,
      tempSelectedCohorts: observable,
      setTempSelectedCohorts: action,
      setCustomDashboardData: action,
      removeCustomDashboardData: action,
    });

    makePersistable(this, {
      name: 'CustomDashboardStore',
      properties: [
        'id',
        'dashboardName',
        'employerGroups',
        'isEdit',
        'planPeriod',
        'selectedStartDate',
        'selectedEndDate',
        'selectedCohorts',
        'tempSelectedCohorts',
      ],
      storage: window.localStorage,
    });
  }

  setCustomDashboardData(
    id: string,
    dashboardName: string,
    employerGroups: EmployerGroups[],
    isEdit: boolean,
    planPeriod: InitialDates,
    selectedStartDate: string,
    selectedEndDate: string,
    selectedCohorts: ICohortDetails[],
  ) {
    this.id = id;
    this.employerGroups = employerGroups;
    this.isEdit = isEdit;
    this.dashboardName = dashboardName;
    this.planPeriod = planPeriod;
    this.selectedStartDate = selectedStartDate;
    this.selectedEndDate = selectedEndDate;
    this.selectedCohorts = selectedCohorts;
  }

  removeCustomDashboardData() {
    this.id = '';
    this.employerGroups = [];
    this.isEdit = false;
    this.dashboardName = '';

    this.planPeriod = {
      start_month: '',
      end_month: '',
      plan_start_month: '',
      start_year: 0,
      end_year: 0,
      plan_end_month: '',
    recent_plan_year: 0
    };
    this.selectedStartDate = '';
    this.selectedEndDate = '';
    this.selectedCohorts = [
      {
        id: 1,
        category: '',
        condition: '',
        property: '',
        results: '',
        dropdownSelectionTypeIndex: 0,
        propertiesPageNumber: 0,
        totalPagesForProperties: 0,
      },
    ];
    this.tempSelectedCohorts = [
      {
        id: 1,
        category: '',
        condition: '',
        property: '',
        results: '',
        dropdownSelectionTypeIndex: 0,
        propertiesPageNumber: 0,
        totalPagesForProperties: 0,
      },
    ];
  }

  setTempSelectedCohorts(tempSelectedCohorts: ICohortDetails[]) {
    this.tempSelectedCohorts = tempSelectedCohorts;
  }
}
export default CustomDashboardStore;
